module.exports = __webpack_public_path__ + "static/media/partnership_3.5ad0b9ca.png";